/**
 * Utitlities for Screen Size and other Properties we may need.
 */

export type Breakpoints = {
  sm: 480;
  md: 768;
  lg: 1024;
  xl: 1280;
  ul: 1440;
};

export const breakpoints: Breakpoints = {
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
  ul: 1440,
};

export const smallestSupportedScreenWidth = 360; // smallest mobile width found on statcounter.com

export function isBp(breakpoint: keyof Breakpoints) {
  return window.matchMedia(`(max-width: ${breakpoints[breakpoint]}px)`).matches;
}

export function isMobile() {
  return isBp("sm");
}

export function isTablet() {
  return isBp("md");
}
